<template>
	<el-dialog :visible.sync="dlgVisible" center title="重复投保" top="25vh" width="80%">
		<avue-crud :data="dataCarRepeat" :option="optionCarRepeat">
			<!--            <template slot="menuLeft">-->
			<!--                <div>该车辆信息已投保成功</div>-->
			<!--                <div>生效日期：<span style="font-weight:bold; color:red">{{ this.dataCarRepeat[0].effectiveDate }}</span></div>-->
			<!--                <div>失效日期：<span style="font-weight:bold; color:red">{{ this.dataCarRepeat[0].expiryDate }}</span></div>-->
			<!--            </template>-->
		</avue-crud>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="dlgVisible = false">我已知晓</el-button>
		</span>
	</el-dialog>
</template>

<script>
import {optionCarRepeat} from '@/const/crud/insurance/policy'

export default {
	name: 'RepeatCarDlg',
	data: function () {
		return {
			dlgVisible: false,
			optionCarRepeat: this.deepClone(optionCarRepeat),
			dataCarRepeat: [],
		}
	},
	methods: {
		setRepeatCar(carInfoList) {
			this.dataCarRepeat = carInfoList || []
			this.dlgVisible = true
		},
	},
}
</script>
